
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { ValidationProvider } from 'vee-validate'
export default {
  components: {
    ValidationProvider
  },
  props: {
    creation: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    inputProps: {
      type: Object,
      default () {
        return {
          label: 'Mot de passe'
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icons: { mdiEye, mdiEyeOff },
      showPassword: false,
      password: ''
    }
  },
  computed: {
    rules () {
      const rules = ['required']

      if (this.creation) {
        rules.push('complex', 'min:16')
      }

      return rules.join('|')
    }
  },
  watch: {
    password () {
      this.$emit('input', this.password)
    }
  }
}
